import React from 'react'

import {Box} from "@mui/material"
import { AppCheckCrossIcon } from "@components"


export default function exportedColumn() {

    return [{
        name: "exported",
        label: "Export Status",
        options: {
            filterType: 'checkbox',
            display: 'excluded',
            customBodyRowRender: value => value ? "Exported" : "Not Exported",
        }
    }, {
        name: 'exported',
        label: 'Exported',
        options: {
            filter: false,
            customBodyRowRenderLite: value => <Box
                sx={{display: 'flex', alignItems: 'center', justifyContent: 'center'}}>
                <AppCheckCrossIcon condition={!!value}/>
            </Box>,
        }
    }]
}